import { serialize, deserialize, Type, Exclude, plainToClass } from "class-transformer";

export class BoxStyleDimension {
  name: string;
  lower_limit: number;
  upper_limit: number;
}

export class BoxStyle {
  id: number;
  name: string;
  implemented: boolean;
  description: string;
  image_url: string;
  dimensions: BoxStyleDimension[];
}

export class Box {
  id: number;
  dimensions: number[] = [];
  style: BoxStyle = null;

  get name() {
    if (this.style != null)
      return this.style.name;
    else
      return 'Loading...';
  }

  get image_url() {
    if (this.style != null)
      return this.style.image_url;
    else
      return '/static/0201_placeholder.png';
  }

  //This function is needed since the dimension vector might be unsorted
  dimensionIndex( dimensionName )
  {
    switch(this.style.name) {
      case 'Shelf9933':
      case 'Shelf9934':
      switch (dimensionName)
        {
          case "Length [mm]": return 0;
          case "Width [mm]": return 1;
        }
      case 'Shelfwall9923':
        switch (dimensionName)
        {
          case "Bottom length [mm]": return 0;
          case "Top length [mm]": return 1;
          case "Width [mm]": return 2;
          case "Height [mm]": return 3;
          case "Crease height [mm]": return 4;
        }
      case 'Shelfwall9921':
      case 'Shelfwall9922':
        switch (dimensionName)
        {
          case "Bottom length [mm]": return 0;
          case "Top length [mm]": return 1;
          case "Width [mm]": return 2;
          case "Height [mm]": return 3;
        }
      case 'FEFCO0460':
        switch (dimensionName)
        {
          case "Length [mm]": return 0;
          case "Width [mm]": return 1;
          case "Height [mm]": return 2;
          case "Top flap [mm]": return 3;
          case "Side flap [mm]": return 4;
          case "Corner flap [mm]": return 5;
        }
        break;
      case 'FEFCO0452':
        switch (dimensionName)
        {
          case "Length [mm]": return 0;
          case "Width [mm]": return 1;
          case "Height [mm]": return 2;
          case "Intake/lowering [mm]": return 3;
        }
        break;
      case 'FEFCO0406':
        switch (dimensionName)
        {
          case "Length [mm]": return 0;
          case "Width [mm]": return 1;
          case "Height [mm]": return 2;
          case "Corner flap [mm]": return 3;
          case "Side flap [mm]": return 4;
        }
        break;

      case 'FEFCO0352':
        switch (dimensionName)
        {
          case "Length [mm]": return 0;
          case "Width [mm]": return 1;
          case "Corner length [mm]": return 2;
          case "Height [mm]": return 3;
        }
        break;

      case 'FEFCO0350':
      case 'FEFCO0351':
        switch (dimensionName)
        {
          case "Corner length [mm]": return 0;
          case "Height [mm]": return 1;
        }
        break;

      case 'FEFCO0200':
      case 'FEFCO0201':
      case 'FEFCO0202':
      case 'FEFCO0203':
      case 'FEFCO0204':
      case 'FEFCO0205':
      case 'FEFCO0206':
      case 'FEFCO0209':
      case 'FEFCO0216':
      case 'FEFCO0218':
      case 'FEFCO0225':
      case 'FEFCO0310':
      case 'FEFCO0312':
      case 'FEFCO0314':
      case 'FEFCO0422':
      case 'FEFCO0423':
      case 'FEFCO0435':
      case 'FEFCO0453':
      case 'FEFCO0501':
      case 'FEFCO0605':
      case 'FEFCO0606':
      case 'FEFCO0607':
      case 'FEFCO0620':
      case 'FEFCO0700':
      case 'FEFCO0701':
      case 'FEFCO0703':
      case 'FEFCO0711':
      case 'FEFCO0712':
      case 'Podium9911':
      case 'Podium9912':
      case 'Podium9913':
      case 'Podium9914':
      case 'Podium9915':
      case 'Podium9916':
      case 'Podium9917':
      case 'Podium9918':
      case 'Podium9919':
      case 'Shelf9931':
      case 'Shelf9932':
      case 'Shelf9941':

        switch (dimensionName)
        {
          case "Length [mm]": return 0;
          case "Width [mm]": return 1;
          case "Height [mm]": return 2;
        }
      break;
    }
  }

  get areaSI() {
    var area = 0;
    switch(this.style.name) {
      case 'Shelf9941':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = W * L + 2 * H * (W + L);
        break;
      case 'Shelf9934':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        area = L * W;
        break;
      case 'Shelf9933':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        area = 2 * L * W;
        break;
      case 'Shelf9932':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = W * (L + H);
        break;
      case 'Shelf9931':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = W * (L + 2 * H);
        break;
      case 'Shelfwall9922':
      case 'Shelfwall9923':
        var Lb = this.dimensions[0];
        var Lt = this.dimensions[1];
        var W = this.dimensions[2];
        var H = this.dimensions[3];
        area = H * (W + 2 * Math.min(Lb,Lt) + Math.abs(Lb - Lt));
        break;
      case 'Shelfwall9921':
        var Lb = this.dimensions[0];
        var Lt = this.dimensions[1];
        var W = this.dimensions[2];
        var H = this.dimensions[3];
        area = H * (W + 4 * Math.min(Lb,Lt) + 2 * Math.abs(Lb - Lt));
        break;

      case 'Podium9911':
      case 'Podium9912':
      case 'Podium9913':
      case 'Podium9914':
      case 'Podium9915':
      case 'Podium9916':
      case 'Podium9917':
      case 'Podium9918':
      case 'Podium9919':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        // Not implemented  - var L_div = this.dimensions[3];
        // Not implemented  - var W_div = this.dimensions[4];
        area = 2 * H * (L + W)  + L * W; // + L * H * (W_div - 1) + W * H * (L_div - 1) ->  Here with L_div == 1 & W_div == 1.
        break;
      case 'FEFCO0712':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = 2 * L * (H + W) + 2 * W * (W + H + 0.5 * L) + 0.03 * H;
        break;
      case 'FEFCO0703':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = 2 * (L + W) * (H + W * 1.5) + 0.03 * H;
        break;
      case 'FEFCO0701':
      case 'FEFCO0711':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = 2 * (L + W) * (H + W) + 0.03 * H;
        break;
      case 'FEFCO0700':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = 2 * (L + W) * (H + W * 0.5) + 0.03 * H;
        break;
      case 'FEFCO0607':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = L * (2 * (W + H) + 0.03) + 2 * (W + 0.06) * (H + 0.06);
        break;
      case 'FEFCO0606':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = 2 * (L + 0.06) * (W + H) + 2 * W * H;
        break;
      case 'FEFCO0605':
      case 'FEFCO0620':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = L * 2 * (W + H) + 2 * (W + 0.06) * (H + 0.06);
        break;
      case 'FEFCO0501':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = H * (2 * (L + W) + 0.03)
        break;
      case 'FEFCO0460':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        var TF = this.dimensions[3];
        var SF = this.dimensions[4];
        var CF = this.dimensions[5];
        area = W * (L + 2 * SF) + 2 * H * L + 4 * (H * CF - 0.5 * (H-SF) * (CF - TF) );
        break;
      case 'FEFCO0452':
      case 'FEFCO0453':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        var IT = this.dimensions[3];
        area = (L + 2*H) * (W + 2*H);
        break;
      case 'FEFCO0435':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = (L + 4*H) * (W + 2*H);
        break;
      case 'FEFCO0423':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = (L + 2*H) * (W + 4*H);
        break;
      case 'FEFCO0422':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = W * (L + 4 * H) + H * (L + 2 * H);
        break;
      case 'FEFCO0406':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        var CF = this.dimensions[3];
        var SF = this.dimensions[4];
        area = 2 * W * (L + 2*SF ) + 2 * H * (L + 2*CF) + 0.03*L;
        break;
      case 'FEFCO0352':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var CL = this.dimensions[2];
        var H = this.dimensions[3];
        area = (2*L + 2*W + 4*CL + 0.03) * H;
        area += 2 * ( L + 1.4*CL + 0.1 ) * (W + 1.4*CL + 0.1);
        break;
      case 'FEFCO0351':
      case 'FEFCO0350':
        var CL = this.dimensions[0];
        var H = this.dimensions[1];
        area = (8 * CL + 0.03) * H +  2 * (2.4 * CL + 0.1) * (2.4 * CL + 0.1);
        break;
      case 'FEFCO0314':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = H * (2 * (L + W) + 0.03) + 2 * (L + 0.02) * (W + 0.01);
        break;
      case 'FEFCO0312':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = 2 * (L + W) * (H + W*0.5) + 0.03 * H + (L + 0.01) * (W + 0.01);
        break;
      case 'FEFCO0310':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = H * (2 * (L + W) + 0.03) + 2 * (L + 0.01) * (W + 0.01);
        break;
      case 'FEFCO0225':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = 2 * (L + W) * (H + W*1.5);
        break;
      case 'FEFCO0209':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = 2 * (L + W) * (H + W*0.5 + 0.03) + 0.03 * H;
        break;
      case 'FEFCO0206':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = 2 * L * (H + 2 * W) +  2 * W * (H + L) + 0.03 * H;
        break;
      case 'FEFCO0205':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = 2 * (L + W) * (H + L) + 0.03 * H;
        break;
      case 'FEFCO0204':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = 2 * L * (H + W) +  2 * W * (H + L) + 0.03 * H;
        break;
      case 'FEFCO0203':
      case 'FEFCO0218':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = 2 * (L + W)*(H + W*2.0) + 0.03 * H;
        break;
      case 'FEFCO0216':
      case 'FEFCO0202':
      case 'FEFCO0201':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = 2 * (L + W) * (H + W) + 0.03 * H;
        break;
      case 'FEFCO0200':
        var L = this.dimensions[0];
        var W = this.dimensions[1];
        var H = this.dimensions[2];
        area = 2 * (L + W)*(H + W*0.5) + 0.03 * H;
        break;
    }
    return area;
  }

  dimensionLowerLimitMM(index : number)
  {
    var limit = this.style.dimensions[index].lower_limit;
    switch (this.style.name) {

      case  'FEFCO0460':
        if ( index == 5 )
          limit = this.dimensions[3] * 1000.0;
        break;
    }
    return limit;
  }

  dimensionUpperLimitMM(index : number)
  {
    var limit = this.style.dimensions[index].upper_limit;
    switch (this.style.name) {

      case  'Shelfwall9923':
        if ( index == 4 )
          limit = Math.min(this.dimensions[3] * 1000.0-5.0, this.style.dimensions[index].upper_limit);
        break;

      case  'FEFCO0460':
        if ( index == 3 )
          limit = Math.min(this.dimensions[1] * 1000.0*0.5-5.0, this.style.dimensions[index].upper_limit);
        else if ( index == 4 )
            limit = Math.min(this.dimensions[2] * 1000.0*0.75, this.style.dimensions[index].upper_limit);
        else if ( index == 5 )
          limit = Math.min(this.dimensions[1] * 1000.0*0.5-5.0, 250); // upper limit not stored in database
        break;

      case  'FEFCO0406':
        if ( index == 3 )
          limit = Math.min(this.dimensions[1] * 1000*0.5, this.style.dimensions[index].upper_limit);
        else if ( index == 4 )
          limit = Math.min(this.dimensions[2] * 1000*0.5, this.style.dimensions[index].upper_limit);
        break;

      case  'FEFCO0352':
        if ( index == 1 )
          limit = Math.min(this.dimensions[0] * 1000, this.style.dimensions[index].upper_limit);
        else if ( index == 2 )
          limit = Math.min(this.dimensions[1] * 1000, this.style.dimensions[index].upper_limit);
        break;

      case 'FEFCO0200':
      case 'FEFCO0201':
      case 'FEFCO0202':
      case 'FEFCO0203':
      case 'FEFCO0204':
      case 'FEFCO0205':
      case 'FEFCO0206':
      case 'FEFCO0209':
      case 'FEFCO0216':
      case 'FEFCO0218':
      case 'FEFCO0225':
      case 'FEFCO0310':
      case 'FEFCO0312':
      case 'FEFCO0314':
      case 'FEFCO0422':
      case 'FEFCO0423':
      case 'FEFCO0435':
      case 'FEFCO0453':
      case 'FEFCO0501':
      case 'FEFCO0605':
      case 'FEFCO0606':
      case 'FEFCO0607':
      case 'FEFCO0620':
      case 'FEFCO0700':
      case 'FEFCO0701':
      case 'FEFCO0703':
      case 'FEFCO0711':
      case 'FEFCO0712':
      case 'FEFCO0452':
        if ( index == 1 )
          limit = Math.min(this.dimensions[0]*1000,this.style.dimensions[index].upper_limit);
        break;
    }
    return limit;
  }

  store(): any {
    return serialize(this);
  }

  static restore(eBox: any) {
    const box = plainToClass<Box, Object>(Box, eBox);
    let sortedList = [];
    for (const dim of box.style.dimensions) {
      sortedList[box.dimensionIndex(dim.name)] = dim;
    }

    box.style.dimensions = sortedList;
    return box;
  }
}



// WEBPACK FOOTER //
// ../common/box.ts